import { useEffect } from 'react';
import { PracticeAnalyticsTypes } from '@frontend/api-analytics';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { useGetNewPatientsMetric } from './hooks/use-get-new-patients-metric';
import { usePracticeAnalyticsShallowStore } from './hooks/use-practice-analytics-store';
import { NewPatientsMetricMulti } from './new-patients-metric-multi';
import { NewPatientsMetricSingle } from './new-patients-metric-single';

const colors = {
  newPatients: theme.colors.warning50,
  completedProduction: theme.colors.success20,
  uncapturedProduction: theme.colors.critical40,
};

export const NewPatientsMetric = (props: PracticeAnalyticsTypes.MetricProps) => {
  const { isDrillDownPage, onFetchStateChange } = props;

  const { t } = useTranslation('analytics');
  const { filters } = usePracticeAnalyticsShallowStore('filters');
  const { aggregatedNewPatientsData, isLoading, rawNewPatientsData } = useGetNewPatientsMetric();

  const multipleLocationsSelected = (filters.locations?.length || 0) > 1;
  const showLocationComparison = isDrillDownPage && multipleLocationsSelected;

  const labels = {
    newPatients: t('New Patients'),
    completedProduction: t('Completed Production ($)'),
    uncapturedProduction: t('Uncaptured Production ($)'),
  };

  useEffect(() => {
    onFetchStateChange?.(isLoading);
  }, [isLoading]);

  return showLocationComparison ? (
    <NewPatientsMetricMulti
      {...props}
      colors={colors}
      data={{
        aggregatedData: aggregatedNewPatientsData,
        rawData: rawNewPatientsData,
      }}
      isLoading={isLoading}
      labels={labels}
    />
  ) : (
    <NewPatientsMetricSingle
      {...props}
      colors={colors}
      data={{
        aggregatedData: aggregatedNewPatientsData,
        rawData: rawNewPatientsData,
      }}
      isLoading={isLoading}
      labels={labels}
    />
  );
};
